import { activityTimelineHeadline } from './activityTimelineHeadline'
import { buildActivityTimelineViews } from './buildActivityTimelineViews'
import { buildThoughtTimelineExtras } from './thoughtTimelineExtras'
import { timelinePhaseMeta } from './timelinePhaseMeta'

export function buildActivityTimelineModel(input) {
  const {
    activity,
    workStatus,
    hasArtifacts,
    runId,
    publicActivity,
    thoughtSummary = null,
    thoughtDetails = [],
    streaming = false,
    now = Date.now(),
    hasResponseText = false,
    clientRunStartedAt = null,
    clientRunCompletedAt = null,
  } = input
  const { view, publicView, hasPublicTimeline } = buildActivityTimelineViews({
    activity,
    workStatus,
    runId,
    publicActivity,
  })
  const { phaseTitles, phaseKinds } = timelinePhaseMeta(publicView)
  const { leading: leadingExtras, trailing: trailingExtras } = buildThoughtTimelineExtras({
    thoughtSummary,
    thoughtDetails,
    workStatus,
    runId,
    streaming,
    hasPublicTimeline,
    phaseTitles,
    phaseKinds,
    hasResponseText,
  })
  const headline = activityTimelineHeadline({
    publicView,
    workStatus,
    runId,
    view,
    hasArtifacts,
    publicActivity,
    hasPublicTimeline,
    streaming,
    now,
    activity,
    thoughtSummary,
    hasResponseText,
    clientRunStartedAt,
    clientRunCompletedAt,
  })
  return { view, publicView, hasPublicTimeline, leadingExtras, trailingExtras, ...headline }
}
